export default "__VITE_ASSET__BKfnkTXt__"